import KhaltiCheckout from "khalti-checkout-web";
import {
  payWithKhalti,
  initiatePayment,
  submitPaymentForm,
} from "../../src/api/paymentApi";
import history from "../history";
import { BASE_URL, API_URL } from "../constants";

const PUBLIC_KEY_KHALTI = process.env.PUBLIC_KEY_KHALTI;
const USE_NEW_KHALTI_API = process.env.REACT_APP_USE_NEW_KHALTI_API !== 'false';

function monitorPaymentWindow(paymentWindow) {
  if (!paymentWindow) return;

  const pollTimer = setInterval(() => {
    try {
      if (paymentWindow.closed) {
        clearInterval(pollTimer);
        console.log('Payment window closed by user');
      }
    } catch (e) {
      // cross-origin — window still open
    }
  }, 1000);

  setTimeout(() => clearInterval(pollTimer), 30 * 60 * 1000);
}

function openPaymentRedirect(paymentUrl) {
  const paymentWindow = window.open(
    paymentUrl,
    'PaymentGateway',
    'width=900,height=700,scrollbars=yes,resizable=yes,centerscreen=yes'
  );

  if (paymentWindow) {
    paymentWindow.focus();
    monitorPaymentWindow(paymentWindow);
    return;
  }

  const userWantsRedirect = window.confirm(
    'Popup was blocked by your browser.\n\n' +
    'Click OK to open payment in this window, or Cancel to stay on this page.'
  );
  if (userWantsRedirect) {
    window.location.href = paymentUrl;
  }
}

function handleInitiationResponse(response, gateway) {
  const data = response?.data || {};
  if (data.type === 'redirect' && data.payment_url) {
    openPaymentRedirect(data.payment_url);
    return;
  }
  if (data.type === 'form' && data.action && data.fields) {
    submitPaymentForm({ action: data.action, fields: data.fields });
    return;
  }
  console.error('Unexpected payment initiation response:', data);
  alert(`Could not start ${gateway} payment. Please try again.`);
}

/**
 * Start checkout on the customer's chosen gateway.
 * @param {'khalti'|'esewa'|'card'} gateway
 */
export async function checkOutWithGateway(gateway, params) {
  const gw = (gateway || 'khalti').toLowerCase();
  try {
    const response = await initiatePayment({
      gateway: gw,
      productIdentity: params.productIdentity,
      amount: params.amount,
      productName: params.productName || 'Visit All Nepal Booking',
      customerName: params.customerName,
      customerEmail: params.customerEmail,
      customerPhone: params.customerPhone,
      payment_currency: params.payment_currency,
    });
    handleInitiationResponse(response, gw);
  } catch (error) {
    const errors = error.response?.data?.errors || [];
    const errorMsg = errors.join(' ') || error.message || 'Could not initiate payment.';
    const alreadyPaid = error.response?.status === 422 && errors.some((e) => /already paid/i.test(e));
    if (alreadyPaid) {
      alert('This booking is already paid. You do not need to pay again.');
    } else {
      alert(`Payment initiation failed: ${errorMsg}`);
    }
    throw error;
  }
}

// Backward compatible alias
export async function checkOutWithKhalti(params) {
  if (!USE_NEW_KHALTI_API) {
    checkOutWithKhaltiOld(params);
    return;
  }
  return checkOutWithGateway('khalti', params);
}

function checkOutWithKhaltiOld(params) {
  const initialParams = {
    publicKey: PUBLIC_KEY_KHALTI,
    productIdentity: "1234567890",
    productName: "VisitallNepal",
    productUrl: BASE_URL || "https://visitallnepal.com/",
    eventHandler: {
      onSuccess(payload) {
        payWithKhalti(payload).then(() => {
          history.push(`/payment_success/${payload.product_identity}`);
        });
      },
      onError(error) {
        console.log(error);
      },
      onClose() {
        console.log("widget is closing");
      },
    },
  };

  const config = { ...initialParams, ...params };
  const checkout = new KhaltiCheckout(config);
  checkout.show({ amount: params.amount * 100 });
}

export { checkOutWithGateway as default };
